import { render, staticRenderFns } from "./phcompany.vue?vue&type=template&id=4bc94beb"
import script from "./phcompany.vue?vue&type=script&lang=js"
export * from "./phcompany.vue?vue&type=script&lang=js"
import style0 from "./phcompany.vue?vue&type=style&index=0&id=4bc94beb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports